import "core-js/modules/es.object.keys.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "modal-content"
};
var _hoisted_2 = {
  class: "title"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1);

var _hoisted_4 = {
  class: "search-container d-flex fl-j-c fl-a-c"
};
var _hoisted_5 = ["placeholder"];
var _hoisted_6 = {
  class: "icon-box d-flex fl-a-c fl-j-c"
};
var _hoisted_7 = {
  class: "campaigns-list"
};
var _hoisted_8 = {
  class: "grouping-letter"
};

var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_PromocodeCampaignExpandedCard = _resolveComponent("PromocodeCampaignExpandedCard");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    class: "promocode-campaigns-modal"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("promocode.campaigns-list")), 1), _hoisted_3, _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
        class: "search-input",
        type: "search",
        placeholder: _ctx.$t('input.promocode-campaigns') + '...',
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.searchQuery = $event;
        })
      }, null, 8, _hoisted_5), [[_vModelText, _ctx.searchQuery]]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_SvgIcon, {
        class: "search-icon",
        iconContent: _ctx.searchIcon,
        iconAlt: "?",
        iconStyle: "width: 33px; height: 33px;"
      }, null, 8, ["iconContent"])])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.groupedCards), function (key) {
        return _openBlock(), _createElementBlock("div", {
          class: "group",
          key: key
        }, [_createElementVNode("p", _hoisted_8, _toDisplayString(key), 1), _hoisted_9, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedCards[key], function (card) {
          return _openBlock(), _createElementBlock("div", {
            key: card.id
          }, [_createVNode(_component_PromocodeCampaignExpandedCard, {
            data: card,
            toggleApplyPromocode: _ctx.toggleApplyPromocode
          }, null, 8, ["data", "toggleApplyPromocode"])]);
        }), 128))]);
      }), 128))])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}